function tournament_Reducer(state = [], action) {
    switch (action.type) {
        case 'TOURNAMENT/SET':
            return action.tournament;
        case 'TOURNAMENT/CLEAR':
            return null;
        default:
            return state;
    }
}

export default tournament_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/tournament.js